import React from 'react';
import { scrollToPurchase } from '../utils/checkout';
export function WhatsIncluded() {
  const skills = ['Choose better light for indoor and outdoor dog photos', 'Use flattering angles that make your dog look their best', 'Capture more personality, expression, and emotion', 'Take better running, playful, and action shots', 'Create more polished, share-worthy final images', 'Stop relying on luck every time you use your phone camera'];
  const books = [{
    number: '1',
    title: 'Getting Started',
    desc: 'How to prepare your dog, your location, and your light before you even tap the screen.'
  }, {
    number: '2',
    title: 'Phone Camera Basics',
    desc: 'How to use your phone more effectively for sharper, clearer, better-looking dog photos.'
  }, {
    number: '3',
    title: 'Poses and Angles',
    desc: 'Simple ways to make your dog look more expressive, flattering, and photogenic.'
  }, {
    number: '4',
    title: 'Personality and Emotion',
    desc: 'How to capture the little moments that actually feel like your dog.'
  }, {
    number: '5',
    title: 'Movement and Action',
    desc: 'Take better running, jumping, playful, and dynamic dog photos with your phone.'
  }, {
    number: '6',
    title: 'Beautiful Final Results',
    desc: "Create more stylish, frame-worthy dog photos you'll want to save, share, and print."
  }];
  return <section className="bg-warm-deep py-16 md:py-24 px-4" data-id="element-315">
      <div className="max-w-3xl mx-auto" data-id="element-316">
        {/* Skills heading */}
        <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-center text-warm-hero mb-10 leading-tight" data-id="element-317">
          Inside The <span className="italic text-soft-gold" data-id="element-318">Pawfect</span> Shot
          MegaPack, you'll learn how to:
        </h2>

        {/* Skills list */}
        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-lg border border-soft-gold/15 mb-12" data-id="element-319">
          <ul className="space-y-4" data-id="element-320">
            {skills.map((item, index) => <li key={index} className="flex items-start" data-id="element-321">
                <span className="text-green-500 mr-4 text-lg mt-0.5 flex-shrink-0" data-id="element-322">
                  ✅
                </span>
                <span className="font-sans text-lg text-gray-700" data-id="element-323">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Books subheading */}
        <h3 className="font-serif text-2xl md:text-3xl font-bold text-center text-warm-hero mb-8" data-id="element-324">
          All delivered inside 6 simple, beginner-friendly guides:
        </h3>

        {/* Books grid */}
        <div className="space-y-4 mb-12" data-id="element-325">
          {books.map(book => <div key={book.number} className="bg-white p-6 md:p-7 rounded-xl shadow-sm border border-soft-gold/15 flex items-start gap-4" data-id="element-326">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-soft-gold to-dark-gold text-white font-sans font-bold text-sm flex items-center justify-center" data-id="element-327">
                {book.number}
              </div>
              <div data-id="element-328">
                <h4 className="font-sans font-bold text-lg text-warm-hero mb-1" data-id="element-329">
                  Book {book.number} — {book.title}
                </h4>
                <p className="font-sans text-gray-600 leading-relaxed" data-id="element-330">
                  {book.desc}
                </p>
              </div>
            </div>)}
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-331">
          <button onClick={scrollToPurchase} className="w-full md:w-auto bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-lg md:text-xl py-4 px-10 rounded-full shadow-cta transition-all duration-300 transform hover:-translate-y-1 uppercase text-center" data-id="element-332">
            👉 Get Instant Access Now
          </button>
        </div>
      </div>
    </section>;
}